import { useQuery } from '@tanstack/react-query';

export const SAVED_CLASSES_QUERY_KEY = 'savedClasses';

interface SavedClassItem {
  contentfulId: string | null;
  liveTrainingId: string;
  contentType: string;
  savedDate: number;
  learningPathContentfulId: string | null;
}

interface SavedClassesResponse {
  savedIds: SavedClassItem[];
  totalCount: number;
}

/**
 * Custom hook to fetch the list of saved classes for the current user
 * @returns Query result with saved class IDs
 *
 * @example
 * const { data, isLoading } = useGetSavedClasses();
 * const isSaved = data?.savedIds.some(item => item.liveTrainingId === courseId);
 */
export const useGetSavedClasses = () => {
  return useQuery({
    queryKey: [SAVED_CLASSES_QUERY_KEY],
    queryFn: async (): Promise<SavedClassesResponse> => {
      const response = await fetch(
        '/gateway/api/learning-app-progress-fe/my-learning/saved-ids?contentType=LIVE_TRAINING',
        {
          method: 'GET',
          credentials: 'include',
        },
      );

      if (!response.ok) {
        throw new Error('Failed to fetch saved classes');
      }

      return response.json();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

